/**
 * Octopus IoT Platform - Activity / ETA API Service
 * Fase C/D da integração LAB → principal.
 *
 * Tudo é READ-ONLY: a máquina de atividade (estado, segmentos, ETA/projeção) é
 * computada e escrita EXCLUSIVAMENTE pelo worker server-side (lab_activity_worker).
 * O frontend só LÊ — respeita INV-LAYER-001 / INV-UI-TRAIL-001.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const activityApi = {
  /** Estado de atividade corrente (carregando/descarregando/parado/viagem + ciclo). */
  getActivity: (equipmentId) => axios.get(`${API}/lab/activity/${equipmentId}`),

  /** ETA até o porto (projeção do worker; arrival_iso já computado no servidor). */
  getEta: (equipmentId) => axios.get(`${API}/lab/eta/${equipmentId}`),

  /** Segmentos FECHADOS (apontamento por etapa). */
  getSegments: (equipmentId, params = {}) =>
    axios.get(`${API}/lab/activity/${equipmentId}/segments`, { params }),

  /** Apontamento por etapa + por motor no período. */
  getSummary: (equipmentId, params = {}) =>
    axios.get(`${API}/lab/activity/${equipmentId}/summary`, { params }),

  /** Viagens FECHADAS (ciclos) detectadas pelo worker (lab_activity_trips). */
  getTrips: (equipmentId, params = {}) =>
    axios.get(`${API}/lab/activity/${equipmentId}/trips`, { params }),

  /** Timeline de regime (eventos de transição da máquina de atividade). */
  getRegimeEvents: (equipmentId, params = {}) =>
    axios.get(`${API}/lab/regime-events`, { params: { equipment_id: equipmentId, ...params } }),

  /**
   * Registra o motivo de parada (despachante → PATCH /api/lab/activity/{id}/stop-reason).
   * payload: { reason: 'clima'|'manutencao'|'quebra_inesperada'|'parada_programada'|'outro',
   *            reason_text?: string }
   * INV-UI-TRAIL-001: única chamada de escrita do frontend — registra intenção humana, não
   * recomputa telemetria.
   */
  setStopReason: (equipmentId, payload) =>
    axios.patch(`${API}/lab/activity/${equipmentId}/stop-reason`, payload),
};

export default activityApi;
